export default "__VITE_ASSET__B41x81q5__"